import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import bannerAmorDeMae from '../assets/banner-amor-de-mae.png'
import bannerAmorDePai from '../assets/banner-amor-de-pai.png'
import bannerEmCasaSimSozinhoNunca from '../assets/banner-em-casa-sim-sozinho-nunca.png'
import bannerDiaDasMaes from '../assets/banner-dia-das-maes.jpg'
import bannerDiaDosNamorados from '../assets/banner-dia-dos-namorados.png'
import bannerAmorPorPG from '../assets/banner-amor-por-pg.png'
import bannerFrioDeLascar from '../assets/banner-frio-de-lascar-pb.jpg'
import bannerPrimavera from '../assets/banner-primavera.png'
import bannerProfessor from '../assets/banner-dia-do-professor.jpg'
import bannerCascavel from '../assets/banner-amor-cascavel.jpg'
import bannerNatal2020 from '../assets/banner-natal-2020.png'
import bannerAmorDeMae2021 from '../assets/amor-de-mae-2021.png'
import bannerDiaDoAmigo2021 from '../assets/bannner-dia-amigo-2021.png'
import bannerMarchaJesus2022 from '../assets/banner-marcha-jesus-2022.png'
import bannerNatal2023 from '../assets/banner-natal-2023.png'
import bannerFamiliaETudo2024 from '../assets/banner-familia-e-tudo-2024.png'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    height: 450,
    width: '100%',
  },
  bannerFilter: {
    position: 'absolute',
    height: 450,
    width: '100%',
    background: theme.palette.primary.dark,
    zIndex: 2,
    // opacity: 0.75,
  },
  banner: {
    height: 450,
    width: '100%',
    zIndex: 1,
    objectFit: 'cover',
  },
}))
const BannerCampanha = ({ pageProps }) => {
  const classes = useStyles()

  let opacity = 0.75
  let banner;

  if (pageProps.url === '/amor-de-mae') {
    banner = bannerAmorDeMae
  }
  if (pageProps.url === '/dia-das-maes') {
    banner = bannerDiaDasMaes
  }
  if (
    pageProps.url === '/em-casa-sim-sozinho-nunca' ||
    pageProps.url === '/vamos-superar-juntos'
  ) {
    banner = bannerEmCasaSimSozinhoNunca
  }
  if (pageProps.url === '/dia-dos-namorados') {
    banner = bannerDiaDosNamorados
  }
  if (pageProps.url === '/amor-de-pai') {
    banner = bannerAmorDePai
  }
  if (pageProps.url === '/frio-de-lascar') {
    banner = bannerFrioDeLascar
  }
  if (pageProps.url === '/amor-por-pg') {
    banner = bannerAmorPorPG
  }
  if (pageProps.url === '/primavera-rpc') {
    banner = bannerPrimavera
  }
  if (pageProps.url === '/dia-do-professor') {
    banner = bannerProfessor
  }
  if (pageProps.url === '/amor-por-cascavel') {
    banner = bannerCascavel
  }
  if (pageProps.url === '/natal-rpc-2023') {
    banner = bannerNatal2023
    opacity = 0
  }
  if (pageProps.url === '/amor-por-guarapuava') {
    banner = bannerNatal2020
  }
  if (pageProps.url === '/amor-por-londrina') {
    banner = bannerNatal2020
  }
  if (pageProps.url === '/amor-por-paranavai') {
    banner = bannerNatal2020
  }
  if (pageProps.url === '/amordemae') {
    banner = bannerAmorDeMae2021
  }
  if (pageProps.url === '/dia-do-amigo-2021') {
    banner = bannerDiaDoAmigo2021
  }
  if (pageProps.url === '/marcha-para-jesus') {
    opacity = 0.5
    banner = bannerMarchaJesus2022
  }
  if (pageProps.url === '/familia-e-tudo') {
    banner = bannerFamiliaETudo2024
  }
  
   return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.bannerFilter} style={{ opacity }}></Grid>
      <Grid item xs={12}>
        <img src={banner} className={classes.banner} alt='Banner' />
      </Grid>
    </Grid>
  )
}
export default BannerCampanha
